/**
 * Города франшизы. Каждый Mini App-сеанс ассоциирован ровно с одним городом —
 * это определяет, в какой филиал попадёт лид и какой менеджер позвонит.
 *
 * Источник города:
 *  - real-режим: window.WebApp.initDataUnsafe.start_param (передаётся через
 *    deeplink бота https://max.ru/<bot>?startapp=<city>). Если start_param
 *    пустой / неизвестный → city=null → /invalid-link. Никакого silent
 *    fallback на shakhty.
 *  - mock-режим: VITE_MOCK_CITY из .env, затем dev-toolbar (для теста на ходу).
 *    Здесь fallback на DEFAULT_CITY допускается — в dev/тестах нет MAX bridge,
 *    поэтому mode пустого start_param это «ладно, дефолт для разработки».
 *
 * Параметр `city` обязателен во всех событиях аналитики (для null —
 * useAnalytics подставляет 'unknown' чтобы не падать).
 */

export type City =
  | 'shakhty'
  | 'aksay'
  | 'azov'
  | 'novoshakhtinsk'
  | 'belaya_kalitva'
  | 'rostov_vorosh';

export const CITIES: readonly City[] = [
  'shakhty',
  'aksay',
  'azov',
  'novoshakhtinsk',
  'belaya_kalitva',
  'rostov_vorosh',
] as const;

export const CITY_LABELS: Record<City, string> = {
  shakhty: 'Шахты',
  aksay: 'Аксай',
  azov: 'Азов',
  novoshakhtinsk: 'Новошахтинск',
  belaya_kalitva: 'Белая Калитва',
  rostov_vorosh: 'Ростов (Ворошиловский)',
};

/**
 * Дефолтный город ТОЛЬКО для mock/dev режима (VITE_MAX_MODE=mock).
 *
 * **Production fallback запрещён.** В real-mode пустой / невалидный start_param
 * → city=null → /invalid-link, не shakhty. См. lib/city.ts resolveCity.
 *
 * Production smoke 2026-05-10 показал, что silent fallback маскировал
 * расхождение belaya-kalitva vs belaya_kalitva несколько недель. Любой
 * fallback в real-mode → лиды пропадают в неправильном филиале молча.
 */
export const DEFAULT_CITY: City = 'shakhty';

export function isCity(value: unknown): value is City {
  return typeof value === 'string' && (CITIES as readonly string[]).includes(value);
}
